var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="customQRCodeInsert_empty"> <form class="contact-form" style="margin-bottom:10px"> <div class="control-group customQRCodeInsert_inputName"> <div class="form-group"> <label for="customQRCodeInsert_inputName">'+
((__t=( resources['X100306'] ))==null?'':__t)+
'</label> <input class="form-control form-control-sm" id="customQRCodeInsert_inputName"> <span class="help-inline" style="color:red"></span> </div> </div> <div id="container" style="visibility:hidden; height:0px"></div> <button type="button" class="btn btn-primary btn-sm col-sm-3" id="customQRCodeInsert_btnSubmit">'+
((__t=( resources['X100283'] ))==null?'':__t)+
'</button> <div id="customQRCodeInsert_qrCodeContainer" style="text-align:center;display:none"> <div id="customQRCodeInsert_container"></div> <img id="customQRCodeInsert_qrCodeLogo" crossorigin="anonymous" src="" style="visibility:visible; height:0px"> </div> </form> </div>';
}
return __p;
};
